import { Observable, of } from "rxjs";
import { switchMap } from "rxjs/operators";

export const switchMapToIfUndefined = <T>(alternative: Observable<T>) =>
	switchMap((value: T) => (value !== undefined ? of(value) : alternative));
